export class mContact {
    public Email: string="";
    public Naam: string="";
    public Onderwerp: String="";
    public Bericht: String="";
    constructor() { }
}
